import { render, staticRenderFns } from "./RAvatar.vue?vue&type=template&id=093aee04&"
import script from "./RAvatar.vue?vue&type=script&lang=js&"
export * from "./RAvatar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QAvatar from 'quasar/src/components/avatar/QAvatar.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QAvatar});
